
import React from "react";
import {ISystemRequirementsWrapper} from "../interfaces";
import AppleIcon from "../../../../ui/svg/common/apple";
import WindowsIcon from "../../../../ui/svg/common/windows";


export interface ISystemRequirementsProps {
    systemRequirementsWrapperProps?:ISystemRequirementsWrapper,
    majorVersion? : string
}
/**
 * the entry point
 */
const TabSysReq = (props?: ISystemRequirementsProps) => {

    const systemRequirementsWrapper = props?.systemRequirementsWrapperProps;
    return (
        <div className="my-4">
            {systemRequirementsWrapper != null && <div className={"my-4"} dangerouslySetInnerHTML={{ __html: systemRequirementsWrapper?.topBanner }} />}
            <div className="product-hosts-list flex flex-col md:flex-row justify-between my-4">
            <ul className="sys-req-list flex flex-col justify-start mt-4 w-full md:w-1/2 md:mr-12 xl:mr-36">
                <li className="icon flex w-full h-12 mb-8 items-center justify-start">
                    <span><AppleIcon width="34" height="40" color="1d1d1d" /></span>
                    <span className="ml-4 text-xl font-bold text-gray-700">Mac</span>
                </li>
                {
                    systemRequirementsWrapper?.systemRequirements?.filter(w=>w.platform === 1).map((sys, index) => {
                        return (
                            <li key={ index }
                                className={""}
                            >
                                <div key={index} dangerouslySetInnerHTML={{ __html: sys.content }} />
                            </li>
                        )
                    })
                }

            </ul>
            <ul className="sys-req-list flex flex-col justify-start mt-4 w-full md:w-1/2">
                <li className="icon flex w-full h-12 mb-8 items-center justify-start">
                    <span><WindowsIcon width="38" height="38" color="1d1d1d" /></span>
                    <span className="ml-4 text-xl font-bold text-gray-700">Windows</span>
                </li>
                {
                    systemRequirementsWrapper?.systemRequirements?.filter(w=>w.platform === 2).map((sys, index) => {
                        return (
                            <li key={ index }
                                className={""}
                                >
                                <div key={index} dangerouslySetInnerHTML={{ __html: sys.content }} />
                            </li>
                        )
                    })
                }
            </ul>
            </div>
            {systemRequirementsWrapper != null && <div className={"my-16"} dangerouslySetInnerHTML={{ __html: systemRequirementsWrapper?.bottomBanner }} />}
        </div>
    )
};

export default TabSysReq;